/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../widgets/livewidget/nls/StringResources',
	'jquery',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI'
], function(stringResources, $, APIFactory, ContentActionsProviderAPI) {

	const PROP_ID_SUPPRESSION = 'suppression';

	class SuppressionAction {
		constructor({ features }) {
			if (features) {
				this.dashboardApi = features.API;
				this._features = features;
				features.ContentActions.registerProvider('suppressionAction', this.getAPI());
			}
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [ContentActionsProviderAPI]);
			}
			return this._api;
		}

		destroy() {
			this.dashboardApi = null;
		}

		isEnabled(idList) {
			const selectedContent = this._getSelectedContent();
			const propertyProvider = selectedContent && selectedContent.getFeature('SuppressionPropertyProvider');
			return idList.length === 1 && propertyProvider && propertyProvider.getPropertyList().length && this.dashboardApi.getMode() !== this.dashboardApi.MODES.EDIT_GROUP;
		}

		getContentActionList(idList) {
			const iconSuppresion = this._features['Icons'].getIcon('iconSuppresion');

			if (this.isEnabled(idList)) {
				return [{
					name: PROP_ID_SUPPRESSION,
					label:  this._getLabel(),
					icon: iconSuppresion.id,
					type: 'Button',
					section: ContentActionsProviderAPI.ACTION_SECTION.SELECTION_VIZ_FORMAT,
					order: 40,
					actions: {
						apply: this._toggleSuppress.bind(this, idList)
					}
				}];
			}
			return [];
		}

		_getSelectedContent() {
			return this.dashboardApi.getCanvas().getSelectedContentList()[0];
		}

		_getLabel(suppressValue){
			suppressValue = suppressValue || this._getValue();
			return suppressValue === 'rowsAndColumns' ? stringResources.get('disableSuppression') : stringResources.get('enableSuppression');
		}

		_getValue() {
			return this._getSelectedContent().getPropertyValue(PROP_ID_SUPPRESSION);
		}

		_toggleSuppress(idList, evt) {
			const propValue = this._getValue();
			const toggleValue =  propValue === 'rowsAndColumns' ? 'none' : 'rowsAndColumns';

			const $suppressBtn = $(evt.currentTarget).find('.suppressBtnToggle').addBack();
			const label = this._getLabel(toggleValue);
			const span = $suppressBtn.find('span');
			if (span) {
				span.text(label);
			}

			this._getSelectedContent().setPropertyValue(PROP_ID_SUPPRESSION, toggleValue);
		}
	}

	return SuppressionAction;

});
